import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9999 17.5C12.9999 18.0523 12.5522 18.5 11.9999 18.5C11.4476 18.5 10.9999 18.0523 10.9999 17.5C10.9999 16.9477 11.4476 16.5 11.9999 16.5C12.5522 16.5 12.9999 16.9477 12.9999 17.5Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7499 9.25C12.7499 8.83579 12.4141 8.5 11.9999 8.5C11.5857 8.5 11.2499 8.83579 11.2499 9.25V13.75C11.2499 14.1642 11.5857 14.5 11.9999 14.5C12.4141 14.5 12.7499 14.1642 12.7499 13.75V9.25Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.83574 3.24404C10.7984 1.57946 13.2014 1.57946 14.1641 3.24404L23.1304 18.7484C24.0943 20.4151 22.8916 22.5 20.9663 22.5H3.03352C1.10822 22.5 -0.0944952 20.4151 0.86936 18.7484L9.83574 3.24404ZM12.8656 3.99498C12.4805 3.32915 11.5193 3.32915 11.1342 3.99498L2.16786 19.4994C1.78231 20.166 2.2634 21 3.03352 21H20.9663C21.7364 21 22.2175 20.166 21.832 19.4994L12.8656 3.99498Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgAlert;
